// @ vendor
const moment = require('moment');

// @ actions
const signaturePatternActions = require('actions/signaturePattern');
const hireCardImageSelectorActions = require('actions/hireCardImageSelector');
const hireContactDataActions = require('actions/hireContactData');
const hireInformationActions = require('actions/hireInformation');
const hireOpenYoungIntervenersActions = require('actions/hireOpenYoungInterveners');
const openYoungTutorTypeActions = require('actions/openYoungTutorType');
const openYoungPersonalDataActions = require('actions/openYoungPersonalData');
const openYoungTaxDataActions = require('actions/openYoungTaxData');
const { setShippingAddress, resetShippingAddress } = require('actions/shippingAddress');
const { resetPreContractualInfo } = require('actions/preContractualInfo');
const { setTermsAndCondsInfo } = require('actions/termsAndCondsInfo');

// @ utilities
const { APIPost } = require('utilities/APIRequestHelper');
const { formatDate } = require('utilities/dateHelper');
const { formatPhoneNumber, getGender } = require('routes/contractsView/utilities/formHelper');
const { scrollToTop } = require('commonsUtilities/scrollUtils');
const { recordLink, PROC_PACK_OPEN_YOUNG } = require('utilities/tagging');
const { getCardStandard, getShippingAddressDetails } = require('utilities/hireCardsHelper');
const { getAvailableHiringCardsImages } = require('./hireCardOpenYoung');

// @ constants
const actionTypes = require('constants/actionTypes');
const {
  OPENYOUNG_ACCOUNT_STANDARD,
  OPENYOUNG_ACCOUNT_SUBTYPE,
  OPENYOUNG_ACCOUNT_TYPE,
  SECOND_STEP,
  THIRD_STEP,
  FIRST_STEP,
} = require('constants/index');
const {
  DATE_FORMAT_API,
  DEFAULT_COUNTRY,
  DEFAULT_DOCUMENT_TYPE,
  EURO_TEXT,
  JUNIOR_ACCOUNT_ACCOUNT_TYPE,
  JUNIOR_ACCOUNT_ACTIVITY_CODE,
  JUNIOR_ACCOUNT_ANNUAL_INCOME_AMOUNT,
  JUNIOR_ACCOUNT_CAMPANA,
  JUNIOR_ACCOUNT_CANAL_COMERCIALIZACION,
  JUNIOR_ACCOUNT_CIVIL_STATUS,
  JUNIOR_ACCOUNT_CNAE93,
  JUNIOR_ACCOUNT_CNO,
  JUNIOR_ACCOUNT_COD_ESTANDAR_REFERENCIA,
  JUNIOR_ACCOUNT_DEVICE1_ORIGIN,
  JUNIOR_ACCOUNT_DEVICE_TYPE,
  JUNIOR_ACCOUNT_FORMATO_DOMIC,
  JUNIOR_ACCOUNT_GESTOR,
  JUNIOR_ACCOUNT_ID_SUB_PRODUCT,
  JUNIOR_ACCOUNT_IND_EMPLOYEE,
  JUNIOR_ACCOUNT_IND_FISCAL_NO,
  JUNIOR_ACCOUNT_IND_PERS_TRABAJA,
  JUNIOR_ACCOUNT_IND_TALONARIO,
  JUNIOR_ACCOUNT_INTERVENTION_TYPE,
  JUNIOR_ACCOUNT_LANGUAGE,
  JUNIOR_ACCOUNT_LEVEL_OF_STUDIES,
  JUNIOR_ACCOUNT_PRODUCT_ID,
  JUNIOR_ACCOUNT_SUB_ACTIVITY_CODE,
  JUNIOR_ACCOUNT_TIPO_DOMIC,
  JUNIOR_ACCOUNT_TIPO_INTERVENCION,
  SPAIN_COUNTRY_CODE,
} = require('constants/index');

const { OPEN_YOUNG_PACK_PRODUCT_ALIAS } = require('constants/hiringProductInformation');
const { NEW_SHIPPING_ADDRESS } = require('constants/shippingAddress');
const { MESSAGE_HIRE_24H } = require('constants/flagBasedFeatures');

const resetWizard = () => ({
  type: actionTypes.HIRE_PACK_OPEN_YOUNG_RESET,
});

const reset = () => dispatch => {
  dispatch(hireInformationActions.reset());
  dispatch(openYoungTutorTypeActions.reset());
  dispatch(openYoungPersonalDataActions.reset());
  dispatch(hireContactDataActions.reset());
  dispatch(openYoungTaxDataActions.reset());
  dispatch(hireOpenYoungIntervenersActions.reset());
  dispatch(hireCardImageSelectorActions.reset());
  dispatch(resetShippingAddress());
  dispatch(resetWizard());
  dispatch(resetPreContractualInfo());
};

const setAccount = accountId => ({
  type: actionTypes.HIRE_PACK_OPEN_YOUNG_SET_ACCOUNT,
  payload: {
    accountId,
  },
});

const setAgreementCheckbox = evt => ({
  type: actionTypes.HIRE_PACK_OPEN_YOUNG_SET_AGREEMENT_CHECKBOX,
  payload: {
    checked: evt.target.checked,
  },
});

const toggleTutorCheckbox = () => ({
  type: actionTypes.HIRE_PACK_OPEN_YOUNG_TOGGLE_TUTOR_CHECKBOX,
});

const setVisibleStep = step => ({
  type: actionTypes.HIRE_PACK_OPEN_YOUNG_SET_VISIBLE_STEP,
  payload: {
    step,
  },
});

const validateAccount = () => ({
  type: actionTypes.HIRE_PACK_OPEN_YOUNG_VALIDATE_ACCOUNT,
});

function validateLoading(loadingFlag) {
  return {
    type: actionTypes.HIRE_CARD_LOADING,
    payload: {
      loadingFlag,
    },
  };
}

const validate = (step, externalComponentsAreValid) => ({
  type: actionTypes.HIRE_PACK_OPEN_YOUNG_VALIDATE_STEP,
  payload: {
    step,
    valid: externalComponentsAreValid,
  },
});

const validateFourthStep = step => (dispatch, getState) => {
  const immHireCardImageSelector = getState().hireCardImageSelector;
  const externalComponentsAreValid = immHireCardImageSelector.get('valid');
  recordLink(
    PROC_PACK_OPEN_YOUNG,
    'personaliza tarjeta',
    immHireCardImageSelector.get('selectedImageId')
  );
  dispatch(validate(step, externalComponentsAreValid));
};

const validateSecondStep = step => (dispatch, getState) => {
  const immHirePackOpenYoung = getState().hirePackOpenYoung;
  const immStep2 = immHirePackOpenYoung.getIn(['steps', SECOND_STEP]);
  const immOpenYoungTutorType = getState().openYoungTutorType;
  const immOpenYoungPersonalData = getState().openYoungPersonalData;
  const immOpenYoungTaxData = getState().openYoungTaxData;
  const immHireContactData = getState().hireContactData;
  const immContactDetails = immHireContactData.getIn([
    'extraInstances',
    'hirePackOpenYoungContact',
  ]);
  let allComponentsAreValid = false;

  if (immStep2.getIn(['tutorCheckbox', 'isValid'])) {
    allComponentsAreValid =
      immOpenYoungTutorType.get('isValid') &&
      immOpenYoungPersonalData.get('isValid') &&
      immContactDetails.get('isValid') &&
      immOpenYoungTaxData.get('isValid');
  }
  dispatch(validate(step, allComponentsAreValid));
};

const validateThirdStep = step => (dispatch, getState) => {
  const immHireOpenYoungInterveners = getState().hireOpenYoungInterveners;
  const accountIsValid = getState().hirePackOpenYoung.getIn([
    'steps',
    THIRD_STEP,
    'accountIsValid',
  ]);

  let allComponentsAreValid = !immHireOpenYoungInterveners.get('errorState') && accountIsValid;

  dispatch(validate(step, allComponentsAreValid));
};

const validateFifthStep = step => (dispatch, getState) => {
  const immShippingAddress = getState().shippingAddress;
  const shippingAddressType = immShippingAddress.get('shippingAddressType');

  let allComponentsAreValid = true;
  if (shippingAddressType === NEW_SHIPPING_ADDRESS) {
    //Send param false in validateStep to show absence of mobile field
    dispatch(hireContactDataActions.validateStep(false));

    const immHireContactData = getState().hireContactData;
    allComponentsAreValid = immHireContactData.get('isValid');

    dispatch(validate(step, allComponentsAreValid));
    //Set shipping address as new correspondance address
    allComponentsAreValid && dispatch(setShippingAddress(NEW_SHIPPING_ADDRESS, immHireContactData));
  } else {
    dispatch(validate(step, allComponentsAreValid));
  }
};

const getStep = step => (dispatch, getState) => {
  const valid = getState().hirePackOpenYoung.getIn(['steps', step - 1, 'valid']);
  if (!valid) {
    scrollToTop();
  }
  return valid;
};

const validateStep = step => (dispatch, getState) => {
  if (step === 2) {
    //SECOND_STEP
    dispatch(openYoungTutorTypeActions.validateStep());
    dispatch(openYoungPersonalDataActions.validateStep());
    dispatch(hireContactDataActions.validateStep(true, 'hirePackOpenYoungContact'));
    dispatch(openYoungTaxDataActions.validateStep());
    dispatch(validateSecondStep(step));
  } else if (step === 3) {
    //THIRD_STEP
    dispatch(validateAccount());
    dispatch(hireOpenYoungIntervenersActions.validateStep());
    dispatch(validateThirdStep(step));
  } else if (step === 4) {
    //FOURTH_STEP
    dispatch(hireCardImageSelectorActions.validateStep());
    dispatch(validateFourthStep(step));
  } else if (step === 5) {
    //FIFTH_STEP
    dispatch(validateFifthStep(step));
  } else if (step === 1 && getState().flagBasedFeatures.get(MESSAGE_HIRE_24H)) {
    const immHirePackOpenYoung = getState().hirePackOpenYoung;
    const immStep1 = immHirePackOpenYoung.getIn(['steps', FIRST_STEP]);
    getAvailableHiringCardsImages(dispatch, getState);

    if(typeof immStep1.get('agreementChecked') === 'boolean' && immStep1.get('agreementChecked') === false){
      dispatch(validateLoading(false));
    dispatch(validate(step, false));
    }
    else {
    const immCards = getState().cards;
    const immCardById = immCards && immCards.get('byId');
    const immCardByOrder = immCards && immCards.get('byOrder');
    const cardObj =
      immCardByOrder &&
      immCardByOrder.map(cardId => {
        const immCard = immCardById && immCardById.get(cardId);
        return {
          contractNumber: immCard.getIn(['contract', 'number']),
          pan: immCard.get('number'),
          product: immCard.get('newProduct'),
          subType: immCard.get('productSubType'),
          standard: immCard.getIn(['product', 'standard']),
        };
      });
    dispatch(validateLoading(true));
    return APIPost({
      dispatch,
      endpoint: 'validateCardHire',
      params: {
        query: { cards: cardObj },
      },
    })
      .then(() => {
        dispatch(validateLoading(false));
    dispatch(validate(step, false));
      })
      .catch(error => {
        if (error) {
          if (error.error.status === 412 && error.body.error === 'HIRE_BLOCKED') {
            dispatch(validate(step, true));
            dispatch(validateLoading(false));
          } else {
            dispatch(hirePackOpenYoungFailure(''));
            dispatch(validateLoading(false));
          }
        }
      });
    }
  } else {
    dispatch(validateLoading(false));
    dispatch(validate(step, false));
  }
  return dispatch(getStep(step));
};

const setWillCancel = willCancel => ({
  type: actionTypes.HIRE_PACK_OPEN_YOUNG_WILL_CANCEL,
  payload: {
    willCancel,
  },
});

const hirePackOpenYoungRequest = () => ({
  type: actionTypes.HIRE_PACK_OPEN_YOUNG_REQUEST,
});

const hirePackOpenYoungSuccess = response => ({
  type: actionTypes.HIRE_PACK_OPEN_YOUNG_SUCCESS,
  payload: {
    response,
  },
});

const hirePackOpenYoungFailure = response => {
  let hireAccountError = false;
  let hireCardError = false;

  if (response.error === 'OY_0001') {
    hireAccountError = true;
  } else if (response.error === 'OY_0002') {
    hireCardError = true;
  }
  return {
    type: actionTypes.HIRE_PACK_OPEN_YOUNG_FAILURE,
    payload: {
      hireAccountError,
      hireCardError,
    },
  };
};

const setAllAccountsToInactive = () => ({
  type: actionTypes.HIRE_PACK_OPEN_YOUNG_SET_ALL_ACCOUNTS_TO_INACTIVE,
});

const setPackOpenYoung = (dispatch, data, termsAndsCondsHiringData) => {
  const requestData = {
    query: data,
    header: {
      version: 2,
    },
  };

  dispatch(hirePackOpenYoungRequest());
  return APIPost({
    dispatch,
    endpoint: 'hirePackOpenYoung',
    params: requestData,
  })
    .then(response => {
      dispatch(hirePackOpenYoungSuccess(response));
      dispatch(setTermsAndCondsInfo(OPEN_YOUNG_PACK_PRODUCT_ALIAS, termsAndsCondsHiringData));
    })
    .catch(response => {
      if (!!response.error) {
        dispatch(hirePackOpenYoungFailure(response.body));
      } else {
        throw response;
      }
    });
};

const buildIntervenersData = immInterveners => {
  return immInterveners.map((immIntervener, index) => ({
    formaIntervencion: JUNIOR_ACCOUNT_INTERVENTION_TYPE,
    numOrdenIntervencion: index + 1,
    numeroPersona: immIntervener.getIn(['identification', 'code']),
    tipoIntervencion: JUNIOR_ACCOUNT_TIPO_INTERVENCION,
    tipoPersona: immIntervener.getIn(['identification', 'type']),
  }));
};

const buildTaxData = immTaxData => {
  let newTaxData = [];

  if (immTaxData.getIn(['hasTaxData', 'value'])) {
    immTaxData.get('byId').forEach(immTaxDataItem => {
      newTaxData.push({
        indMotivoTributacion: immTaxDataItem.getIn(['reason', 'value']),
        pais: immTaxDataItem.getIn(['country', 'value']),
        tin: {
          codigodocumpersonacorp: immTaxDataItem.getIn(['tin', 'value']),
          tipodocumpersonacorp: DEFAULT_DOCUMENT_TYPE,
        },
      });
    });
  }

  return newTaxData;
};

const hirePackOpenYoung = () => (dispatch, getState) => {
  const callback = (dispatch, getState, dataToken) => {
    const accountId = getState().hirePackOpenYoung.getIn(['steps', THIRD_STEP, 'accountId']);
    const immAccount = getState().accounts.getIn(['byId', accountId]);
    const accountCurrency = immAccount.getIn(['balance', 'currency']);
    const accountContractNumber = immAccount.get('contractNumber');
    const accountProduct = immAccount.get('product');

    const selectedImageId = getState().hireCardImageSelector.get('selectedImageId');
    const cardDesignKey = getCardStandard(selectedImageId);
    const selectedImageIdArray = selectedImageId.split('.');

    const immHireContactData = getState().hireContactData;
    const immContactDetails = immHireContactData.getIn([
      'extraInstances',
      'hirePackOpenYoungContact',
    ]);
    const contactPostalCode = immContactDetails.getIn(['postalCode', 'value']);
    const contactRoadName = immContactDetails.getIn(['roadName', 'value']);
    const contactNumber = immContactDetails.getIn(['number', 'value']);
    const contactOthers = immContactDetails.getIn(['others', 'value']);
    const contactPopulation = immContactDetails.getIn(['population', 'value']);
    const contactProvince = immContactDetails.getIn(['province', 'value']);
    const contactMobile = immContactDetails.getIn(['mobile', 'value']);
    const contactRoadType = immContactDetails.getIn(['roadType', 'value']);

    const immPersonalData = getState().openYoungPersonalData;
    const personalLastName = immPersonalData.getIn(['lastName', 'value']);
    const personalLastName2 = immPersonalData.getIn(['lastName2', 'value']);
    const personalDocumentNumber = immPersonalData.getIn(['documentNumber', 'value']);
    const personalBirthDate = formatDate(
      immPersonalData.getIn(['birthDate', 'value']),
      DATE_FORMAT_API
    );
    const personalGender = getGender(immPersonalData.getIn(['gender', 'value']));
    const personalNationality = immPersonalData.getIn(['nationality', 'value']);
    const personalName = immPersonalData.getIn(['name', 'value']);
    const personalCountry = immPersonalData.getIn(['country', 'value']);
    const personalPopulation = immPersonalData.getIn(['population', 'value']);
    const personalProvince = immPersonalData.getIn(['province', 'value']);
    const personalDocumentType = immPersonalData.getIn(['documentType', 'value']);

    const immTutorType = getState().openYoungTutorType.get('value');

    const intervenersData = buildIntervenersData(getState().hireOpenYoungInterveners.get('list'));

    const taxData = buildTaxData(getState().openYoungTaxData);

    //shipping address details
    const immShippingAddress = getState().shippingAddress;
    const shippingAddressType = immShippingAddress.get('shippingAddressType');
    let shippingAddressDetail = null;
    let numDomicilio = null;

    if (shippingAddressType === NEW_SHIPPING_ADDRESS) {
      const immContactData = getState().hireContactData;
      shippingAddressDetail = getShippingAddressDetails(immContactData);
    } else {
      numDomicilio = immShippingAddress.getIn(['shippingAddress', 'numDomicilio']);
    }

    const data = {
      anoIngresos: moment().year(),
      campana: JUNIOR_ACCOUNT_CAMPANA,
      canalComercializacion: JUNIOR_ACCOUNT_CANAL_COMERCIALIZACION,
      canalOperacion: JUNIOR_ACCOUNT_CANAL_COMERCIALIZACION,
      cardDesignKey,
      cnae93: JUNIOR_ACCOUNT_CNAE93,
      cno: JUNIOR_ACCOUNT_CNO,
      codActividad: JUNIOR_ACCOUNT_ACTIVITY_CODE,
      codEstandarReferencia: JUNIOR_ACCOUNT_COD_ESTANDAR_REFERENCIA,
      codMoneda: accountCurrency,
      codProvincia: personalProvince,
      codSubActiv: JUNIOR_ACCOUNT_SUB_ACTIVITY_CODE,
      cuentaSeleccionadaCcc: {
        digitodecontrol: '00',
        numerodecuenta: '0000000000',
      },
      dataToken,
      datosDeContacto: {
        codigoPostal: contactPostalCode,
        nombreVia: contactRoadName,
        numero: contactNumber,
        piso: contactOthers,
        poblacion: contactPopulation,
        provincia: contactProvince,
        telefonoMovil: contactMobile,
        tipoVia: contactRoadType,
      },
      datosPersonales: {
        apellido1: personalLastName,
        apellido2: personalLastName2,
        documento: personalDocumentNumber,
        fechaNacimiento: personalBirthDate,
        genero: personalGender,
        nacionalidad: personalNationality,
        nombre: personalName,
        paisNacimiento: personalCountry,
        pobNacim: personalPopulation,
        provNacim: personalProvince,
        relacion: immTutorType,
        tipoDocumento: personalDocumentType,
      },
      descActividad: 'Desocupado',
      descPlaza: personalCountry,
      dirElectr: {
        listaDirElect: [
          {
            dirElectr1: formatPhoneNumber(SPAIN_COUNTRY_CODE + contactMobile),
            horaDesde1: '00:00:00',
            horaHasta1: '23:59:59',
            origenDisp1: JUNIOR_ACCOUNT_DEVICE1_ORIGIN,
            tipoDispositivo1: JUNIOR_ACCOUNT_DEVICE_TYPE,
          },
        ],
      },
      estadoCivil: JUNIOR_ACCOUNT_CIVIL_STATUS,
      formatoDomic: JUNIOR_ACCOUNT_FORMATO_DOMIC,
      gestor: JUNIOR_ACCOUNT_GESTOR,
      idioma: JUNIOR_ACCOUNT_LANGUAGE,
      idProducto: JUNIOR_ACCOUNT_PRODUCT_ID,
      idSubproducto: JUNIOR_ACCOUNT_ID_SUB_PRODUCT,
      indEmpleado: JUNIOR_ACCOUNT_IND_EMPLOYEE,
      indFiscal: JUNIOR_ACCOUNT_IND_FISCAL_NO,
      indPersTrabaja: JUNIOR_ACCOUNT_IND_PERS_TRABAJA,
      indTalonario: JUNIOR_ACCOUNT_IND_TALONARIO,
      ingAnuales: {
        divisa: EURO_TEXT,
        importe: JUNIOR_ACCOUNT_ANNUAL_INCOME_AMOUNT,
      },
      listaIntervinientes: {
        dato: intervenersData,
      },
      listaPaisTributacion: {
        datosTributacion: taxData,
      },
      nivelEstudios: JUNIOR_ACCOUNT_LEVEL_OF_STUDIES,
      numerodecontrato: accountContractNumber,
      paisDomic: DEFAULT_COUNTRY,
      paisResid: DEFAULT_COUNTRY,
      producto: accountProduct,
      restoDomicilio: contactOthers,
      tipoCuenta: JUNIOR_ACCOUNT_ACCOUNT_TYPE,
      tipoDomic: JUNIOR_ACCOUNT_TIPO_DOMIC,
      numDomicilio,
      deliverToProvidedDetails: true,
      shippingAddressDetail,
      //TODO: To be replace with actual data once get approved
      nombreAdicional: '',
      nombreBeneficiario: '',
    };

    const termsAndsCondsHiringData = [
      {
        standard: OPENYOUNG_ACCOUNT_STANDARD,
        subType: OPENYOUNG_ACCOUNT_SUBTYPE,
        type: OPENYOUNG_ACCOUNT_TYPE,
      },
      {
        standard: `0000${selectedImageIdArray[3]}`,
        subType: selectedImageIdArray[2],
        type: selectedImageIdArray[1],
      },
    ];

    setPackOpenYoung(dispatch, data, termsAndsCondsHiringData);
  };

  new Promise(() => {
    signaturePatternActions.validateAndExecute(dispatch, getState, callback);
  });
};

module.exports = {
  hirePackOpenYoung,
  reset,
  setAccount,
  setAgreementCheckbox,
  setAllAccountsToInactive,
  setVisibleStep,
  setWillCancel,
  toggleTutorCheckbox,
  validate,
  validateStep,
};
